import { ChatResponse } from "build-ts/chat";
import showToast from "hooks/useCustomToast";
import { ChatRequest, ClearChatRequest } from "build-ts/agent";

export const startChat = async(initialData : ChatRequest) : Promise<ChatResponse> => {
  try{
      const chatResponse = await fetch(process.env.REACT_APP_RUN_TIGA!, {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(ChatRequest.toJSON(initialData))
      });

      if(!chatResponse.ok){
          showToast("Failed to start chat", "", "error");
      }

      const data = await chatResponse.json();
      return data[0];
  } catch (error) {
      showToast("Error in starting chat", "", "error");
      throw error;
  }
};

export const continueChat = async (chatRequest: ChatRequest) : Promise<Response> => {
  try{
    const chatResponse = await fetch(process.env.REACT_APP_RUN_TIGA!, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(ChatRequest.toJSON(chatRequest)) 
    });

    if(!chatResponse.ok){
      showToast("Failed to start chat", "", "error");
    }
    return chatResponse;
  } catch (error) {
    showToast("Error in starting chat", "", "error");
    throw error;
  }
};

export const clearChat = async (request: ClearChatRequest) : Promise<Response> => {
  try{
    const response = await fetch(process.env.REACT_APP_CLEAR_CHAT!, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(ClearChatRequest.toJSON(request))
    });

    if(!response.ok){
        showToast("Failed to clear chat", "", "error");
    }

    return response;
  } catch (error) {
      showToast("Error in starting chat", "", "error");
      throw error;
  }
};

export const sendFeedback = async (execution_id: string, feedback: "GOOD" | "BAD"): Promise<Response> => {
    try {
        const response = await fetch(process.env.REACT_APP_FEEDBACK_TISA!, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
                execution_id,
                feedback
            })
        });

        if (!response.ok) {
            throw new Error("Failed to send feedback");
        }
        return response;
    } catch (error) {
        showToast("Error sending feedback", "", "error");
        throw error;
    }
};